const wholeDollarFormat = new Intl.NumberFormat(
    'en-US',
    {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }
);
const dollarAndCentsFormat = new Intl.NumberFormat(
    'en-US',
    {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }
);

// Sort number array in ascending order
export const sortNumbersAsc = (numberArray) => numberArray.sort((a, b) => Number(a) - Number(b));

// Sort number array in descending order
export const sortNumbersDesc = (numberArray) => numberArray.sort((a, b) => Number(b) - Number(a));

/**
 * Format number as money
 * @param {Number} value
 * @param {true | false | 'auto'} showDecimals
 * @returns String
 */
export const formatMoney = (value, showDecimals = 'auto') => {
    const hasZeroCents = value % 1 === 0;

    switch (true) {
        case showDecimals === 'auto' && hasZeroCents:
        case showDecimals === false: {
            return wholeDollarFormat.format(value);
        }
        default: {
            return dollarAndCentsFormat.format(value);
        }
    }
};

function getNextRoundedAmount(current, increment) {
    return Math.floor((current + increment) / increment) * increment;
}

// Build array of nubers with increment
export const buildIncrementedList = (min, max, increment) => {
    const values = [];

    for (var current = min; current < max; current = getNextRoundedAmount(current, increment)) {
        values.push(current);
    }

    values.push(max);
    return values;
};
